import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListPeoplePathParameters } from 'api/actions/hr-list-people/hr-list-people-path-parameters';
import { HrListPeopleResponse } from 'api/actions/hr-list-people/hr-list-people-response';

type HrListPeopleQueryParameters = Record<string, any>;

/**
 * The path of the HrListPeople action.
 */
export const hrListPeopleActionPath = new SweetPath<keyof HrListPeoplePathParameters>('/api/hr/people', {
  path: '{param}',
});

/**
 * Creates a contextualized HrListPeople actions.
 */
export default function createHrListPeopleAction(axios: AxiosInstance) {
  return function hrListPeopleAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HrListPeopleQueryParameters } = {}) {
    const path = hrListPeopleActionPath.original;

    return axios.request<HrListPeopleResponse, HrListPeopleResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
